var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2933 9.12909C13.5169 8.96713 13.5669 8.65452 13.405 8.43086C13.243 8.2072 12.9304 8.15719 12.7067 8.31915L9.5 10.6413V1C9.5 0.723858 9.27614 0.5 9 0.5C8.72386 0.5 8.5 0.723858 8.5 1V10.6413L5.29325 8.31915C5.06959 8.15719 4.75699 8.2072 4.59503 8.43086C4.43307 8.65452 4.48308 8.96713 4.70674 9.12909L8.70674 12.0256C8.88172 12.1523 9.11828 12.1523 9.29325 12.0256L13.2933 9.12909ZM17.5 12.5859C17.5 12.3098 17.2761 12.0859 17 12.0859C16.7239 12.0859 16.5 12.3098 16.5 12.5859V16.4997H1.5L1.5 12.5859C1.5 12.3098 1.27614 12.0859 1 12.0859C0.723858 12.0859 0.5 12.3098 0.5 12.5859V16.9997C0.5 17.2759 0.723858 17.4997 1 17.4997H17C17.2761 17.4997 17.5 17.2759 17.5 16.9997V12.5859Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.8135eadf252855e5f602fec848f9284d.svg";
export { ForwardRef as ReactComponent };